export class TableController
{
  constructor ( table )
  {
    this.table = table;
    this.tableController = this.table.querySelector( '.p-search-table__scroll.is--controller' ) || false;
    this.tableBody = this.table.querySelector( '.p-search-table__scroll.is--body' ) || false;
    this.tableHead = this.table.querySelectorAll( '.p-search-table__head' ) || false;
    this.tableControllerRow = this.table.querySelectorAll( '.p-search-table__controller-item' ) || false;
    this.tableRow = this.table.querySelectorAll( '.p-search-table__list' ) || false;
    this.tableItems = new Object();

    this.tableHead.forEach( ( tableHead, index1 ) => {
      const key = tableHead.getAttribute( 'data-sort-key' ) || false;
      let array = new Array();
      this.tableRow.forEach( ( tableRowItem, index2 ) => {
        array.push( { num: index2, value: tableRowItem.querySelector( '.p-search-table__item:nth-of-type(' + ( index1 + 1 ) + ')' ).textContent } );
      } );
      this.tableItems[ key ] = array;
    } );

    /**
     * 行に番号を振る
     */
    this.tableRow.forEach( ( tableRowItem, index ) => {
      tableRowItem.setAttribute( 'data-row-number', index );
    } );
    this.tableControllerRow.forEach( ( tableControllerRowItem, index ) => {
      tableControllerRowItem.setAttribute( 'data-row-number', index );
    } );
  }

  sortDESC ( key )
  {
    $( this.tableRow ).remove();

    let target = Object.assign( [], this.tableItems[ key ] );
    target.sort((a, b) =>
      a.value > b.value ? -1 : 1
    );

    for ( let i = 0; i < target.length; i++ ) {
      $( this.tableController ).append( this.tableControllerRow[ target[ i ].num ] );
      $( this.tableBody ).append( this.tableRow[ target[ i ].num ] );
    }
  }

  sortASC ( key )
  {
    $( this.tableRow ).remove();

    let target = Object.assign( [], this.tableItems[ key ] );
    target.sort((a, b) =>
      a.value > b.value ? 1 : -1
    );

    for ( let i = 0; i < target.length; i++ ) {
      $( this.tableController ).append( this.tableControllerRow[ target[ i ].num ] );
      $( this.tableBody ).append( this.tableRow[ target[ i ].num ] );
    }
  }

  sortDefault ()
  {
    $( this.tableRow ).remove();

    for ( let i = 0; i < this.tableRow.length; i++ ) {
      $( this.tableController ).append( this.tableControllerRow[ i ] );
      $( this.tableBody ).append( this.tableRow[ i ] );
    }
  }
}
